module.exports = __webpack_public_path__ + "img/banner3_2_vi.e1480e2c.png";